import React from "react";
import { entries } from "lodash";
import { cn } from "../../lib/utils";
import { mealInds } from "../../utils/mealIndUtils";
import { today } from "../../utils/dateUtils";
import { Plan2PlateDatepicker } from "../Plan2PlateDatepicker";
import { Plan2PlateIcon } from "../Plan2PlateIcon";

interface MealIndToggleRowProps {
  date: Date;
  onDateChange: (date: Date) => void;
  selectedMealInd: string;
  onMealIndChange: (mealInd: string) => void;
}

export const MealIndToggleRow = ({
  date,
  onDateChange,
  selectedMealInd,
  onMealIndChange,
}: MealIndToggleRowProps) => (
  <div className="flex items-center gap-1">
    <Plan2PlateDatepicker
      date={date}
      updateDate={onDateChange}
      minDate={today()}
    />
    {entries(mealInds)
      .filter(([, data]) => data.stockRelevant)
      .map(([ind, data]) => (
        <button
          key={ind}
          type="button"
          onClick={() => onMealIndChange(ind)}
          className={cn(
            "flex h-9 w-9 items-center justify-center rounded-card border transition",
            ind === selectedMealInd
              ? "border-teal"
              : "border-transparent opacity-50",
          )}
        >
          <Plan2PlateIcon icon={data.icon} size="sm" />
        </button>
      ))}
  </div>
);
